import { colors } from 'pixel-base'
import styled from 'styled-components'

const Store = styled.div`
  border-radius: 5px 5px 5px 5px;
  border: 1px solid transparent;
  padding: 20px;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &.active {
    border-color: ${colors.primaryActive};
    /* background: linear-gradient(to right, rgb(125, 155, 203), rgb(29, 10, 73)); */
    position: relative;
    z-index: 1;
    left: 1px;
    width: 100%;
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    border-color: ${colors.primaryActive};
    /* background: linear-gradient(to right, rgb(125, 155, 203), rgb(29, 10, 73)); */
    position: relative;
    z-index: 1;
    left: 1px;
    width: 100%;
    transition: all 0.2s ease-in-out;
  }
`
const PlatformChoice = styled.div<{ padding?: string }>`
  color: rgba(104, 118, 140, 0.8);
  font-size: 15px;
  line-height: 1.5;
  margin: 15px auto;
  max-width: 450px;
  font-weight: 600;
  align-self: center;
  padding: ${(props) => props.padding || '0px'};
`

const InFlowContainer = styled.div`
  text-align: center;
`

const InFlowTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${colors.blueLight};
  text-align: center;
`
const InFlowDescription = styled.div`
  color: rgba(104, 118, 140, 0.8);
  font-size: 15px;
  line-height: 1.5;
  margin: 15px auto;
  max-width: 400px;
  text-align: center;
`
const InFlowActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 15px;
`

const HelperWebSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  /* margin: 10px; */
`

export {
  Store,
  PlatformChoice,
  InFlowContainer,
  InFlowTitle,
  InFlowDescription,
  InFlowActions,
  HelperWebSection,
}
